import { useEffect } from "react";
import {
  Modal,
  Button,
  Table,
  Drawer,
  Card,
  Row,
  Col,
} from "../../../../components/common/utils/antd-imports/AntdImports.js";
import "./FeaturedCampaignsModal.css";
import { useDispatch, useSelector } from "react-redux";
import { featuredCampaignProducts } from "../../../../store/thunks/seller-thunks/SellerThunk";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { formatDate } from "../../../../components/common/utils/Utils.js";
import { addBreadcrumb } from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice.js";

const FeaturedCampaignsModal = ({
  featureModal,
  setFeatureModal,
  productDetails,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const productId = productDetails?.id;
  const { isLoading, featuredCampaignsList } = useSelector((state) => state.sellerCampaigns);
  const goToSubPage = ({ title, path }) => {
    dispatch(addBreadcrumb({ title, path }));
  };
  const navigateToCampaign = (record) => {
    goToSubPage({
      title: record.name,
      path: `/seller/viewCampaigns/campaignDetails/${btoa(record?.id)}`,
    });
    navigate(`/seller/viewCampaigns/campaignDetails/${btoa(record?.id)}`);
  };

  const CAMPAIGN_STATUS = {
    "campaign-preparing": 100,
    "campaign-created": 200,
    "quote-requested": 300,
    "quote-given": 400,
    "change-requested": 500,
    "booking-requested": 600,
    scheduled: 700,
    running: 800,
    suspended: 900,
    stopped: 1000,
    "deleted-cancelled": 1200,
    "rfp-campaign": 1300,
    "metro-campaign-created": 1101,
    "metro-campaign-checked-out": 1121,
    "metro-campaign-locked": 1131,
    "metro-campaign-running": 1141,
    "metro-campaign-stopped": 1151,
  };

  // converting status from integer to string using CAMPAIGN_STATUS
  const convertStatusToLabel = (campaigns) => {
    const statusMap = Object?.fromEntries(
      Object?.entries(CAMPAIGN_STATUS)?.map(([label, value]) => [value, label])
    );

    return (
      campaigns &&
      campaigns?.map((campaign) => ({
        ...campaign,
        status: statusMap[campaign?.status] || "",
      }))
    );
  };

  const isMobile = useMediaQuery({ maxWidth: "767px" });
  const columns = [
    {
      title: "Campaign ID",
      dataIndex: "cid",
      key: "cid",
      align: "left", // Center text
      width: 190,
    },
    {
      title: "Campaign Name",
      dataIndex: "name",
      key: "name",
      align: "left", // Center text
      width: 190,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "left", // Center text
      width: 190,
    },
    {
      title: "Date Entered",
      dataIndex: "updated_at",
      key: "updated_at",
      align: "left", // Center text
      render: (text) => formatDate(text),
      width: 190,
    },
    {
      title: <div style={{ textAlign: "center" }}>Actions</div>,
      dataIndex: "status",
      key: "status",
      align: "center", // Center text
      render: (text, record) => (
        <a
          onClick={() => navigateToCampaign(record)}
          className="navigate-campaign"
        >
          View Campaign Details
        </a>
      ),
      width: 190,
    },
  ];
  const handleCancel = () => {
    setFeatureModal(false);
  };

  useEffect(() => {
    if (productId) {
      dispatch(featuredCampaignProducts(productId));
    }
  }, [productId]);

  return (
    <div>
      {isMobile ? (
        <Drawer
          className="mobile-featured-drawer"
          title={
            <p className="mobile-featured-title">Featured in 3 Campaigns </p>
          }
          size="default"
          placement="top"
          closable={true}
          onClose={() => setFeatureModal(false)}
          open={featureModal}
        >
          <div className="mobile-featured-content">
            <div className="product-title">
              Product Name : {productDetails?.title}
            </div>
            <span className="campaign-list">List of Campaigns</span>
          </div>
          {featuredCampaignsList &&
            convertStatusToLabel(featuredCampaignsList)?.map((campaign) => {
              return (
                <Card className="featured-campaigns-mobile-card">
                  <Row gutter={[4, 34]}>
                    <Col span={13}>
                      <div className="featured-label">Campaign ID</div>
                      <div className="featured-value">{campaign?.cid}</div>
                    </Col>
                    <Col span={11}>
                      <div className="featured-label">Status</div>
                      <div className="featured-value">{campaign?.status}</div>
                    </Col>
                    <Col span={13}>
                      <div className="featured-label">Campaign Name</div>
                      <div className="featured-value">{campaign?.name}</div>
                    </Col>
                    <Col span={11}>
                      <div className="featured-label">End Date</div>
                      <div className="featured-value">
                        {formatDate(campaign?.created_at)}
                      </div>
                    </Col>
                    <Col className="view-campaign" span={24}>
                      <a
                        onClick={() => navigateToCampaign(campaign)}
                        className="navigate-campaign"
                      >
                        View Campaign Details
                      </a>
                    </Col>
                  </Row>
                </Card>
              );
            })}
        </Drawer>
      ) : (
        <Modal
          width={isMobile ?? "100%"}
          className="featured-modal"
          maskProps={{ style: { backgroundColor: "rgba(0,0,0,0.1" } }}
          open={featureModal}
          title={
            <span className="featured-product-header">
              Featured in Campaigns
            </span>
          }
          onCancel={() => {
            setFeatureModal(false);
          }}
          footer={
            <Button
              className="comments-close-btn billboard-button-2"
              onClick={handleCancel}
            >
              Close
            </Button>
          }
        >
          <>
            <div className="product-title">
              Product Name : {productDetails?.title}
            </div>
            <span style={{ fontFamily: "Roboto" }}>List of Campaigns</span>
            <Table
              loading={isLoading}
              className="featured-campaigns-table"
              dataSource={convertStatusToLabel(featuredCampaignsList)}
              columns={columns}
              tableLayout="fixed"
            ></Table>
          </>
        </Modal>
      )}
    </div>
  );
};

export default FeaturedCampaignsModal;
